import { useInfraStore } from '@/lib/store/infra';
import { InfraList } from './InfraList';
import { InfraDetail } from './InfraDetail';

export function InfraContext() {
  const id = useInfraStore((s) => s.selectedId);
  return id ? <InfraDetail id={id} /> : <InfraList />;
}
